import { FaBarcode } from "react-icons/fa";
import { IconType } from "react-icons";

import FacebookIcon from "assets/icons/facebook-round.svg";
import InstagramIcon from "assets/icons/instagram-round.svg";
import LinkedinIcon from "assets/icons/linkedin-round.svg";
import YoutubeIcon from "assets/icons/youtube-round.svg";

type Page = {
  name: string;
  slug: string[];
  key: string;
  icon?: IconType;
  url?: string;
  ariaLabel?: string;
  showLink: boolean;
  param?: string;
  type?: string;
  subMenu?: Page[];
};

export const pages = (): Page[] => {
  return [
    {
      name: "Boletos",
      slug: ["boleto-rapido"],
      key: "boletos",
      icon: FaBarcode,
      showLink: true,
    },
  ];
};

export const socials = [
  {
    img: FacebookIcon,
    alt: "Facebook",
    href: "https://www.facebook.com/ultragazoficial/",
  },
  {
    img: YoutubeIcon,
    alt: "Youtube",
    href: "https://www.youtube.com/user/UltragazBrasilgas",
  },
  {
    img: InstagramIcon,
    alt: "Instagram",
    href: "https://www.instagram.com/ultragazoficial/",
  },
  {
    img: LinkedinIcon,
    alt: "Linkedin",
    href: "https://www.linkedin.com/company/ultragaz/mycompany/",
  },
];
